import React from "react";
import PropTypes from "prop-types";

import { Autocomplete, TextField, createFilterOptions } from "@mui/material";

const JumboAutoComplete = ({
  value,
  label,
  options,
  onChange,
  isMulti,
  error,
  helperText,
  required,
  fullWidth,
  size,
  getOptionLabel,
  variant,
  name,
  ...rest
}) => {
  return (
    <Autocomplete
      {...rest}
      multiple={isMulti}
      options={options}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, val) => {
        if (option?._id && val?._id) return option._id === val._id;
        if (option?.id && val?.id) return option.id === val.id;
        return option === val;
      }}
      filterOptions={
        rest.filterOptions ||
        ((opts, state) => {
          const inputValue = (state.inputValue || "").toLowerCase();
          
          const matchedOptions = opts.filter((option) => {
            let label = "";
            if (getOptionLabel && typeof getOptionLabel === "function") {
               const res = getOptionLabel(option);
               if (res !== undefined && res !== null) label = res;
            } else {
               label = option?.name || option?.title || option?.label || "";
            }
            return label && label.toString().toLowerCase().includes(inputValue);
          });

          const unique = [];
          const seenLabelText = new Set();
          
          for (const item of matchedOptions) {
            let label = "";
            if (getOptionLabel && typeof getOptionLabel === "function") {
               const res = getOptionLabel(item);
               if (res !== undefined && res !== null) label = res;
            } else {
               label = item?.name || item?.title || item?.label || "";
            }

            if (!label) continue;
            
            // Absolutely wipe duplicate text renderings (Redux clones, freeSolos, API multiples)
            const visualKey = label.toString().toLowerCase().trim();
            if (!seenLabelText.has(visualKey)) {
              seenLabelText.add(visualKey);
              unique.push(item);
            }
          }
          
          return unique;
        })
      }
      onChange={onChange}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          variant={variant}
          label={label}
          fullWidth={fullWidth}
          error={error || helperText !== ""}
          helperText={helperText}
          required={required}
          size={size}
        />
      )}
    />
  );
};

JumboAutoComplete.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  isMulti: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  size: PropTypes.string,
  getOptionLabel: PropTypes.func,
  variant: PropTypes.string,
  name:PropTypes.string
};

JumboAutoComplete.defaultProps = {
  options: [],
  fullWidth: true,
  required: false,
  size: "small",
  variant: "outlined",
  error: false,
  helperText: "",
  onChange: () => {},
  getOptionLabel: () => {},
};

export default JumboAutoComplete;
